import { useQuery } from '@tanstack/react-query';

import api from '@/services/api';
import { PaymentPricing } from '@/types/payment-account';

export const publicPaymentPricingKeys = {
  all: ['public-payment-pricing'] as const,
};

/**
 * `GET /payment-account/pricing/public` (T8.1, sem login) — mesmos números
 * de `usePaymentPricing`, mas para quem ainda não tem conta: a central de
 * ajuda pública (`/ajuda/recebimentos`) e qualquer outra tela pública que
 * precise citar taxa, prazo ou limite. Arquivo à parte de
 * `use-payment-pricing.ts` de propósito (comentário de lá, T1.6): não espera
 * `useAuthHydration`, porque essas telas rodam sem sessão — inclusive antes
 * de a store de auth existir, no primeiro load do site.
 */
export function usePublicPaymentPricing(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: publicPaymentPricingKeys.all,
    queryFn: async () => (await api.get<PaymentPricing>('/payment-account/pricing/public')).data,
    enabled: options?.enabled !== false,
    // Mesmo motivo do hook autenticado: número muda por platform_settings,
    // não por ação do visitante.
    staleTime: 5 * 60 * 1000,
  });
}
